import { PayloadAction } from "@reduxjs/toolkit";
import { baseURL, establecerEstado, handleResponse, headers, limpiarEstado, reestablecerEstado, seteaError, structureInfoState } from "../helpersRedux";
import { setBancosTarjetas, setFormasDePagoPorConductor, setGuiaEnRutaDetallle, setGuiasEnRuta, setMarcasTarjeta, setMotivosDevolucion, setTiposTarjetas } from "../slices/liquidacionRutasSlice";
import axios, { AxiosResponse } from "axios";
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import {LogisticaTiposFormaPago} from '@pcgerente-node/pcg-comun'
import { BODEGA_FORMAPAGO, FORMAPAGO, LISTAS, MOTIVO_DEVOLUCION, logistica_GUIA, logistica_MANIFIESTO_DETALLE } from "@pcgerente-node/pcg-comun/dist/DTOs";



export const conseguirManifiestosDetallesEnRutas = (desde: string, hasta: string , idDocumento: number, nombreDestinatario: string, entregaUrgente: number, tipo: LogisticaTiposFormaPago, permiteEntregarConManifiesto: number, numeroDocumento: number, idConductor : number) =>
async (dispatch:(action: PayloadAction<structureInfoState<logistica_MANIFIESTO_DETALLE[]>>) => void) => {
  try{
    dispatch(setGuiasEnRuta(reestablecerEstado()))
    let queryParams = `?idDocumento=${idDocumento}&entregaUrgente=${entregaUrgente}&permiteEntregarConManifiesto=${permiteEntregarConManifiesto}&desde=${desde}&numeroDocumento=${numeroDocumento}&idConductor=${idConductor}&tipo=${tipo}`
    
    if(hasta){
      queryParams=`${queryParams}&hasta=${hasta}`
    }
    if(nombreDestinatario){
      queryParams=`${queryParams}&nombreDestinatario=${nombreDestinatario}`
    }

    const response = await axios.get(`${baseURL}logistica_GUIA/EnRuta${queryParams}`, headers)
    .then((res: AxiosResponse<IApiResponse<logistica_MANIFIESTO_DETALLE[]>>) => handleResponse(res))
    dispatch(setGuiasEnRuta(establecerEstado(response)))
  }catch(err){
    if(err instanceof Error){
      dispatch(setGuiasEnRuta(seteaError(err)))
    }
  }
};

export const conseguirDetallesDeGuiaEnRuta = (uuidManifiestoDetalle: string, idUsuario: number) =>
async (dispatch:(action: PayloadAction<structureInfoState<logistica_GUIA>>) => void) => {
  dispatch(setGuiaEnRutaDetallle(limpiarEstado(new logistica_GUIA())))
  try {
    const response = await axios.get(`${baseURL}logistica_GUIA/EnRuta/${uuidManifiestoDetalle}?idUsuario=${idUsuario}`, headers)
    .then((res: AxiosResponse<IApiResponse<logistica_GUIA>>) => handleResponse(res))

      dispatch(setGuiaEnRutaDetallle(establecerEstado(response)))
  } catch (error) {
    if(error instanceof Error)
      dispatch(setGuiaEnRutaDetallle(seteaError(error, new logistica_GUIA())))
  }
}

export const limpiarDetallesDeGuiaEnRuta = () =>
async (dispatch:(action: PayloadAction<structureInfoState<logistica_GUIA>>) => void) => {
  dispatch(setGuiaEnRutaDetallle(reestablecerEstado(new logistica_GUIA())))
}

export const ObtenerFormasDePagoPorConductor = (idCiudadDestino: number, idCiudadUsuario: number, idBodegaUsuario: number) =>
  async (dispatch:(action: PayloadAction<structureInfoState<FORMAPAGO[]>>) => void) => {
  try{  
    dispatch(setFormasDePagoPorConductor(reestablecerEstado()))
    const response = await axios.get(`${baseURL}BODEGA/FORMAPAGO?idCiudadDestino=${idCiudadDestino}&idCiudadUsuario=${idCiudadUsuario}&idBodega=${idBodegaUsuario}`, headers)
      .then((res: AxiosResponse<IApiResponse<BODEGA_FORMAPAGO[]>>) => handleResponse(res))

    // Filtrar formas de pago
    const formasPagoUnicas: FORMAPAGO[] = response.reduce((acum, fp_bodega) => {
      const fp = fp_bodega.FORMAPAGO!!;
      if (!acum.some((fpExistente) => fpExistente.id === fp.id)) {
        acum.push(fp);
      }
      return acum;
    }, [] as FORMAPAGO[]);


    dispatch(setFormasDePagoPorConductor(establecerEstado(formasPagoUnicas)));

    } catch (error) {
      if(error instanceof Error){
        dispatch(setFormasDePagoPorConductor(seteaError(error)))
      }
  }
}

export const obtenerMotivosDevolucion = () =>
async (dispatch:(action: PayloadAction<structureInfoState<MOTIVO_DEVOLUCION[]>>) => void) => {
  dispatch(setMotivosDevolucion(limpiarEstado()))
  try {
    const response = await axios.get(`${baseURL}logistica_MOTIVO_DEVOLUCION`, headers)
    .then((res: AxiosResponse<IApiResponse<MOTIVO_DEVOLUCION[]>>) => handleResponse(res))
    dispatch(setMotivosDevolucion(establecerEstado(response)))
    
  } catch (error) {
    if(error instanceof Error){
      dispatch(setMotivosDevolucion(seteaError(error)))
    }
  }
}
export const llenarTipoTarjeta= () =>
    async (dispatch:(action: PayloadAction<structureInfoState<LISTAS[]>>) => void) => {
    dispatch(setTiposTarjetas(limpiarEstado()))
    try {
      const response = await axios.get(`${baseURL}LISTAS?tabla=TIPO_TARJETA`, headers)
      .then((res: AxiosResponse<IApiResponse<LISTAS[]>>) => handleResponse(res))
      dispatch(setTiposTarjetas(establecerEstado(response)))
    } catch (error) {
        if (error instanceof Error)
            dispatch(setTiposTarjetas(seteaError(error)))
    }
}
export const llenarBancoTarjeta= () =>
async (dispatch:(action: PayloadAction<structureInfoState<LISTAS[]>>) => void) => {
  dispatch(setBancosTarjetas(limpiarEstado()))
  try {
    const response = await axios.get(`${baseURL}LISTAS?tabla=BANCO_TARJETA`, headers)
        .then((res: AxiosResponse<IApiResponse<LISTAS[]>>) => handleResponse(res))
    dispatch(setBancosTarjetas(establecerEstado(response)))
  } catch (error) {
    if (error instanceof Error)
      dispatch(setBancosTarjetas(seteaError(error)))
  }
}
export const llenarMarcaTarjeta= () =>
async (dispatch:(action: PayloadAction<structureInfoState<LISTAS[]>>) => void) => {
  dispatch(setMarcasTarjeta(limpiarEstado()))
  try {
    const response = await axios.get(`${baseURL}LISTAS?tabla=MARCA_TARJETA`, headers)
        .then((res: AxiosResponse<IApiResponse<LISTAS[]>>) => handleResponse(res))
    dispatch(setMarcasTarjeta(establecerEstado(response)))
  } catch (error) {
    if (error instanceof Error)
      dispatch(setMarcasTarjeta(seteaError(error)))
  }
}
export const limpiarEstadoLiquidacionRutasSlice = () =>
  async (dispatch:(action: PayloadAction<structureInfoState<logistica_MANIFIESTO_DETALLE[]|LISTAS[]|MOTIVO_DEVOLUCION[]|logistica_GUIA>> ) => void) => {
    dispatch(setGuiasEnRuta(reestablecerEstado()))
    dispatch(setBancosTarjetas(reestablecerEstado()))
    dispatch(setMarcasTarjeta(reestablecerEstado()))
    dispatch(setTiposTarjetas(reestablecerEstado()))
    dispatch(setMotivosDevolucion(reestablecerEstado()))
    dispatch(setGuiaEnRutaDetallle(reestablecerEstado(new logistica_GUIA())))
}
